import React from 'react';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import { Globe, Mail, Phone } from '@yme/assets/icons/destinations';
import { Image } from '@yme/atoms/image';
import { useWindowSize } from '@yme/common/hooks';
import { AmbassadorInfoStyled, DescriptionStyled, ImageWrapperStyled, SubtitleStyled, TitleStyled, TitleTextStyled, } from '@yme/components/Destinations/Ambassadors/AmbassadorCard/styled';
import { OverviewComponent } from '@yme/components/Destinations/components';
import { Link } from '@yme/components/Link';
import { getIsInAuthor } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { AspectRatio, BLANK } from '@yme/utils/constants';
import { getProductURL } from '@yme/utils/product';
export function AmbassadorCard({ data: { ambassadorName, ambassadorEmail, ambassadorIntro, ambassadorPhone, ambassadorWebsiteUrl, ambassadorPhoto, _path, }, detailsPageUrl, }) {
    const isInAuthor = useSelector(getIsInAuthor);
    const { isInfiniteDesktopView } = useWindowSize();
    const { t } = useTranslation();
    const overviewData = [
        {
            text: ambassadorPhone && React.createElement("a", { href: `tel: ${ambassadorPhone}` }, ambassadorPhone),
            icon: Phone,
        },
        {
            text: ambassadorEmail && React.createElement("a", { href: `mailto: ${ambassadorEmail}` }, ambassadorEmail),
            icon: Mail,
        },
        {
            text: ambassadorWebsiteUrl && (React.createElement("a", { href: ambassadorWebsiteUrl, target: BLANK }, ambassadorWebsiteUrl)),
            icon: Globe,
        },
    ];
    const link = detailsPageUrl &&
        getProductURL({
            path: detailsPageUrl,
            isInAuthor,
            slug: _path.split('/').at(-1),
        });
    return (React.createElement(FlexWrapper, { justifyContent: "space-between", alignItems: "flex-start", flexDirection: isInfiniteDesktopView ? 'row' : 'column-reverse' },
        React.createElement(AmbassadorInfoStyled, null,
            React.createElement(SubtitleStyled, { color: colorCoreBlack300 }, t('destinations_ambassadorMeet_label')),
            React.createElement(TitleStyled, null,
                React.createElement(TitleTextStyled, { as: link && Link, to: link }, ambassadorName)),
            ambassadorIntro && (React.createElement(DescriptionStyled, { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(ambassadorIntro.html),
                } })),
            React.createElement(OverviewComponent, { config: overviewData, isRoundIcon: true })),
        React.createElement(ImageWrapperStyled, { as: link && Link, to: link },
            React.createElement(Image, { src: ambassadorPhoto?._path ?? '', alt: ambassadorName, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "cover" }))));
}
